<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
        <ion-title><HomeButton/> Statistiken </ion-title>


      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <p>Hier finden Sie einige Statistiken:</p>
      <table width="100%">
        <tr>
          <td class="label">Aufgaben gesamt</td>
          <td class="value">{{ store.state.tasks.length}} </td>
        </tr>
        <tr>
          <td class="label">davon erledigt</td>
          <td class="value">{{ completeTasks()}} </td>
        </tr>
        <tr>
          <td class="label">davon nicht erledigt</td>
          <td class="value">{{ incompleteTasks() }} </td>
        </tr>
        <tr>
          <td class="label">Erstellte Reviews</td>
          <td class="value">{{ store.state.reviews.length}} </td>
        </tr>
        <tr>
          <td class="label">für so viele Aufgaben</td>
          <td class="value">{{ reviewedTasks() }} </td>
        </tr>
      </table>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {IonPage, IonContent, IonToolbar, IonButtons, IonBackButton} from '@ionic/vue'
import {defineComponent} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import {useStore} from "@/store/store";
import {createEmptyTool, Tool, ToolUtils} from "@/store/state";
import HomeButton from "@/components/HomeButton.vue";
import MarkdownIt from "markdown-it"
import {TaskState, Task, Review} from "@/store/state";


export default defineComponent({
  components: {HomeButton, IonPage, IonContent, IonToolbar, IonButtons, IonBackButton},
  name: "Stats",

  methods: {
    completeTasks(){
      return this.store.state.tasks.filter((t: Task) => t.state === TaskState.Done ).length
    },
    incompleteTasks(){
      return this.store.state.tasks.filter((t: Task) => t.state != TaskState.Done ).length
    },
    reviewedTasks(){
      return this.store.state.reviews.map(r => r.tasks.length).reduce((a,b)=>a+b,0)
    }
  },
  setup(props) {

    const router = useRouter();
    const {t, locale} = useI18n()
    const store = useStore();

    //scheiss workaround, bis das routing richtig funktioniert
    const route = useRoute();
    return {
      t,
      locale,
      router,
      store}
  }
});
</script>

<style scoped>

ion-slides {
  height: 100%;
}
</style>